import {absCenter, absCenterY, clearfix, font_s_sm} from '@xpertdox_js/xdstyle';
import {colors} from '../defaultSettings';

export default {
  absCenter: {...absCenter},
  container: {
    marginBottom: '41px',
  },
  cellContainer: {
    ...clearfix,
    position: 'relative',
    zIndex: 2,
    whiteSpace: 'nowrap',
    userSelect: 'none'
  },
  innerCell: {
    display: 'inline-block',
    position: 'relative',
    marginBottom: '-3px',
    minHeight: '42px',
    borderBottom: '1px solid ' + colors.cellBorder,
    padding: '0',
    overflow: 'hidden',
    ...font_s_sm,
  },
  innerCellContent: {
    ...absCenterY,
    padding: '6px 2px 6px 6px',
  },
  dropdownContainer: {
    color: colors.text,
    background: colors.bg.layer3,
    animation: 'slide-in-from-top .25s ease-out',
    zIndex: 1,
    position: 'relative',
  },
  listCell: {
    margin: 0,
    listStyle: 'none',
    paddingInlineStart: 6,
    paddingLeft: 0,
  },
  lineNumber: {
    display: 'block',
    position: 'relative',
    width: '15px',
    transition: 'height .28s',
    textAlign: 'center',
    zIndex: 3,
    background: colors.bg.header,
    color: colors.headerText,
    borderRight: '1px solid ' + colors.panelBorder,
  },
  lineNumberNumber: {
    ...absCenter,
    fontSize: '.8rem',
    display: 'block',
  },
  activeItemsBackground: {
    background: colors.bg.panel,
    height: '23px',
    width: '100%',
    position: 'absolute',
    bottom: '50px',
    top: 'auto',
  },
  buttonCell: {
    background: 'none',
    width: '100%',
    padding: 0,
    height: '100%',
    fill: colors.text,
    display: 'block',
  },
  buttonCellHov: {
    fill: colors.highlight
  },
  emptyPlaceholder: {
    background: colors.bg.headerMenu,
    minHeight: '400px',
    position: 'relative',
    width: '100%'
  },
  emptyTitle: {
    fontSize: '2.4rem',
    fontWeight: 'bold',
  },
  emptySvg: {
    width: '80px',
    height: '80px',
    margin: '0 auto',
    display: 'block',
  },
  emptyContent: {
    ...absCenter,
    width: '90%',
    textAlign: 'center',
    color: colors.textGray,
    fill: colors.textGray,
  },
  cellSwitch: {
    container: {
      background: colors.bg.off,
    },
    containerOn: {
      background: colors.bg.on,
    },
    text: {
      fontSize: '1.2rem',
    }
  },
}
